const NOT_NUMBERS_AND_ALPHABETS = /[^A-Za-z0-9]+/g
/**
 * 半角英数字入力制御
 * @param {string} str - 入力制御対象の文字列
 * @return {string} - 半角英数字以外を除外した文字列を返す
 */
export function extractNumbersAndAlphabets(str: string) {
  return str.replace(NOT_NUMBERS_AND_ALPHABETS, "")
}
